module.exports = __webpack_public_path__ + "img/step1.ffc8efc6.png";